<template>
  <div class="table-wrap">
    <table class="app-table">
      <thead>
        <tr>
          <th></th>
          <th>App Name</th>
          <th>App ID</th>
          <th>Country / Region</th>
          <th>Created</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="6" class="state-cell">
            <Spinner size="small" />
          </td>
        </tr>
        <tr v-else-if="!apps.length">
          <td colspan="6" class="state-cell">No apps available</td>
        </tr>
        <tr
          v-else
          v-for="app in apps"
          :key="app.app_id"
          :class="rowClass(app)"
          @click="handleSelect(app)"
        >
          <td>
            <div class="c-radio" :class="{ checked: selectedAppId === app.app_id }">
              <div class="c-dot"></div>
            </div>
          </td>
          <td>
            <div class="td-name">{{ app.app_name }}</div>
          </td>
          <td>
            <div class="td-id">{{ app.app_id }}</div>
          </td>
          <td>
            <div class="td-muted">{{ getRegionName(app.region) }}</div>
          </td>
          <td>
            <div class="td-muted td-date">{{ app.create_time }}</div>
          </td>
          <td>
            <app-status-badge :enabled="app.status !== 0" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import AppStatusBadge from './AppStatusBadge.vue'

export default {
  name: 'ShoplazzaAppTable',
  components: {
    Spinner,
    AppStatusBadge,
  },
  props: {
    apps: {
      type: Array,
      default: () => [],
    },
    selectedAppId: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    regions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isDisabled (app) {
      return app.status === 0
    },
    rowClass (app) {
      const disabled = this.isDisabled(app)
      const selected = this.selectedAppId === app.app_id
      return {
        selected,
        disabled,
      }
    },
    handleSelect (app) {
      if (this.isDisabled(app)) return
      this.$emit('select', app)
    },
    getRegionName (code) {
      const region = this.regions.find((item) => item.code === code)
      return region ? region.name : code
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.table-wrap {
  width: 100%;
  overflow-x: hidden;
}

.app-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 14px;

  thead tr {
    background: #f9fafb;
    border-bottom: 1px solid $border-light;
  }

  thead th {
    padding: 12px 10px;
    font-size: 12px;
    font-weight: 600;
    color: $ink-3;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-align: left;

    &:nth-child(1) { width: 40px; padding-left: 12px; padding-right: 4px; }
    &:nth-child(2) { width: 26%; }
    &:nth-child(3) { width: 24%; }
    &:nth-child(4) { width: 16%; }
    &:nth-child(5) { width: 18%; }
    &:nth-child(6) { width: 96px; padding-right: 12px; }
  }

  tbody tr {
    border-bottom: 1px solid $border-light;
    transition: background 0.15s;

    &:not(.disabled) {
      cursor: pointer;
    }

    &:not(.disabled):hover {
      background: rgba(249, 250, 251, 0.8);
    }

    &.selected {
      background: $green-bg;
    }

    &.disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }
  }

  tbody td {
    padding: 12px 10px;
    vertical-align: middle;

    &:nth-child(1) { padding-left: 12px; padding-right: 4px; }
    &:nth-child(6) { padding-right: 12px; }
  }
}

.c-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  &.checked {
    border-color: $green;
    background: $green;

    .c-dot {
      display: block;
    }
  }

  .c-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    display: none;
  }
}

.td-name {
  font-weight: 600;
  color: $ink;
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.td-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: $ink-4;
  word-break: break-all;
  line-height: 1.4;
}

.td-muted {
  font-size: 12px;
  color: $ink-3;
  word-break: break-word;
  line-height: 1.4;
}

.td-date {
  white-space: normal;
}

.state-cell {
  text-align: center;
  padding: 32px 16px !important;
  color: $ink-4;
}

@media (max-width: 768px) {
  .table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  // 小屏强制保持表格一定宽度，保证可以水平滚动查看完整信息
  .app-table {
    min-width: 720px;
  }
}
</style>
